import _extends from "@babel/runtime/helpers/esm/extends";
import { useMutation as useReactMutation } from 'react-query';
import { forEach, isEmpty, omit } from 'lodash';
import { useLogger } from '@lumahealthhq/ui-utils';
import { useQueryClient } from '../hooks';
export default function useMutation(basePaths, mutationFn, options) {
  const queryClient = useQueryClient();
  const logger = useLogger();
  const mutation = useReactMutation(_extends({
    mutationFn
  }, options, {
    onSettled: (data, error, variables, context) => {
      // Invalidate basePaths
      forEach(basePaths, queryKey => {
        if (!isEmpty(queryKey)) {
          queryClient.invalidateQueries(queryKey).catch(logger.warn);
          logger.debug('queryKey invalidated:', queryKey);
        }
      });
      if (options != null && options.onSettled) {
        options.onSettled(data, error, variables, context);
      }
    }
  }));
  return {
    data: mutation.data,
    error: omit(mutation.error || null, ['name', 'config']),
    isError: mutation.isError,
    isLoading: mutation.isLoading,
    isSuccess: mutation.isSuccess,
    status: mutation.status,
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync
  };
}